import { Card, CardBody, Col, Container, Row } from "reactstrap";
import MainLayout from "../../layouts/MainLayout";
import { ReactComponent as EmptyIcon } from '../../assets/images/icons/empty.svg';
import { useEffect, useState } from "react";
import { API_URL } from "../../utils/constants";
import { toast } from "react-toastify";
import moment from "moment";
import { Link } from "react-router-dom";

function NotificationsPage() {
  const [notifications, setNotifications] = useState();
  const [loading, setLoading] = useState(true);

  const getNotifications = () => {
    setLoading(true);

    fetch(API_URL+'/user/notifications', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    })
    .then(response => response.json())
    .then(data => {      
      if(data.success) {
        setNotifications(data.notifications);
      }
      setLoading(false);
    })
    .catch(error => {
      setLoading(false);
      toast.error('حدث خطأ أثناء جلب الإشعارات');
    });
  }

  useEffect(() => {
    getNotifications();
  }, []);

  return(
    <MainLayout>
      <section className="py-4">
        <Container>
          <Row className="align-items-center justify-content-center">
            <Col lg="8" md="10">
              <h3 className="fw-normal mb-3">الإشعارات</h3>

              {loading ?
                <div className="loader-container">
                  <div className="loader"></div>
                </div>
              :
                notifications?.length > 0 ?
                  <div className="notifications-list">
                    {notifications.map((notification, index) => (
                      <Card key={index} className="mb-3 border">
                        <CardBody>
                          {notification.url &&
                            <Link to={notification.url} className="stretched-link" />
                          }
                          <h6 className="mb-1">{notification.content}</h6>
                          <small className="text-muted">
                            {notification?.created_at &&
                              moment(notification.created_at)
                                .fromNow()
                                .replace(/[٠-٩]/g, d => '٠١٢٣٤٥٦٧٨٩'.indexOf(d))
                            }
                          </small>
                        </CardBody>
                      </Card>
                    ))}
                  </div>
                :
                  <div className="text-center">
                    <EmptyIcon />

                    <h6 className="mt-4 fw-normal text-muted">لا توجد اشعارات</h6>
                  </div>
              }
            </Col>
          </Row>
        </Container>
      </section>
    </MainLayout>
  );
}

export default NotificationsPage;